import { useEffect, useRef } from 'react';
import { without } from 'lodash';

const useAnimationFrame = () => {
  const requestIdsRef = useRef([]);
  const scheduleAnimationFrame = callback => {
    const requestId = requestAnimationFrame(() => {
      callback();
      requestIdsRef.current = without(requestIdsRef?.current, requestId);
    });
    requestIdsRef.current.push(requestId);

    return requestId;
  };

  useEffect(() => {
    return () => {
      requestIdsRef.current.forEach(requestId => cancelAnimationFrame(requestId));
      requestIdsRef.current = [];
    };
  }, []);

  return { scheduleAnimationFrame };
};

export default useAnimationFrame;
